import React, {useState, useEffect} from 'react';
import { getDocs , collection , db , setDoc , doc , deleteDoc } from '../../firebase';
import SideBar from '../components/Sidebar';
import sidebar_menu from '../components/sidebar-menu';


function PackagesMangment (  ) {
  
    const [ packagesArray , setPackagesArray ] = useState([]);
    const [ supportedPlaces , setSupportedPlaces ] = useState([]);

  

    const [addShow , setAddShow] = useState(false);
    const [showTable , setTableShow] = useState(true);

    const [updateShow , setUpdateShow] = useState(false);
    const [ deleteShow , setDeleteShow] = useState(false);

    const [success , setSuccess ] = useState(false);

    const [error , setError ] = useState('');

    const [ packageName , setPackageName ] = useState('');
    const [ packageDesc , setPackageDesc ] = useState('');
    const [ packageImage , setPackageImage ] = useState('');
    const [ packageCateogry , setPackageCategory ] = useState('');
    const [ packagePrice , setPackagePrice ] = useState('');
    const [packageStars , setPackageStars ] = useState('');
    const [packageLocation , setPackageLocation ] = useState('');
    const [packageStatus , setPackageStatus ] = useState('');

    const [refereLocation , setRefereLocation ] = useState('');

    const [photoUrl , setPhotoUrl] = useState('');

    const [placeName , setPlaceName] = useState('');
    const [placeImage , setPlaceImage] = useState('');
    const [placeDesc , setPlaceDesc] = useState('');



    const [markerPhotos , setMarkerPhotos ] = useState('');
    const [markerSections , setMarkerSections ] = useState('');
  


    const [packageId , setPackageId ] = useState('');

    const pushIntoPhotos = ( param ) => {

        setMarkerPhotos(oldArray => [...oldArray, param]);
        setPhotoUrl('');
       
      }

      const pushNewSection = ( name , desc , image ) => {

        let tempObject = {
            name , desc , image
        }
        setMarkerSections(oldArray => [...oldArray, tempObject]);
        setPlaceName('');
        setPlaceDesc('');
        setPlaceImage('');

       
      }

    const makeid = (length) =>  {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * 
     charactersLength));
       }
       return result;
    }

    
  useEffect(  () => {

    const getPackagesData = async () => { 
      const querySnapshot = await getDocs(collection(db, "packages"));
      const usersDataArray = querySnapshot.docs
      .map((doc) => ({ ...doc.data(), id: doc.id }));
        
      setPackagesArray(usersDataArray);
     
    }
    getPackagesData();
  } , []);

  useEffect(  () => {
    
      
    const getSupportedPlaces = async () => { 
      const querySnapshot = await getDocs(collection(db, "supported_places"));
      const placesDataArray = querySnapshot.docs
      .map((doc) => ({ ...doc.data(), id: doc.id }));
        
      setSupportedPlaces(placesDataArray);
     
    }
    getSupportedPlaces();
  } , []);


    const addNewPackage =  async (e) => {

        e.preventDefault();
     

        if (packageName === ''  ) {
                    setError(' يرجى ادخال اسم البكج ');
        }

        if (packageDesc === ''  ) {
                    setError(' يرجى ادخال وصف البكج ');
        }

        if (packageImage === ''  ) {
          setError(' يرجى ادخال صورة البكج ');
        }


     if (packageCateogry === ''  ) {
      setError(' يرجى ادخال فئة البكج ');
     }

     if (packagePrice === ''  ) {
      setError(' يرجى ادخال سعر البكج ');
     }

     


     if (packageStars === ''  ) {
      setError(' يرجى ادخال عدد نجوم البكج ');
     }
     if (packageLocation === ''  ) {
        setError(' يرجى ادخال مكان البكج ');
        }
     if (packageStars === ''  ) {
        setError(' يرجى ادخال حالة البكج ');
        }

   

            
        if (packageName !== '' && packagePrice !== '' && packageStars && packageLocation && packageCateogry && packageImage  && packageStatus   ) {

            const packages = await setDoc(doc(db, "packages", makeid(20)), {
              name : packageName,
              image: packageImage,
              category: packageCateogry,
              photos :  markerPhotos,
              sections : markerSections,
              stars : packageStars,
              description : packageDesc,
              location: packageLocation,
              status : packageStatus,
              refere_location: refereLocation
              
             
              });

            
                setSuccess(true);
                setError('');

                setTimeout(() => {
                    setSuccess('');
                    window.location.reload();
                } , 1350);

             

        }
    }

    const updateShownMethod = ( name , desc , image , category   , price , stars    , location , status , id ) => {

        setPackageName(name);
        setPackageDesc(desc);
        setPackageImage(image);
        setPackageCategory(category);
        setPackagePrice(price);
        setPackageStars(stars);
        setPackageLocation(location);
        setPackageStatus(status);
     
        setPackageId(id);
    
    
    
        determineShow('update');
      }

      const deleteShowMethod = ( name , desc ,  image , category   , price , stars    , location , status ,  id ) => {

        setPackageName(name);
        setPackageDesc(desc);
        setPackageImage(image);
        setPackageCategory(category);
        setPackagePrice(price);
        setPackageStars(stars);
        setPackageLocation(location);
        setPackageStatus(status);
        setPackageId(id);
    
            
        determineShow('delete');
      }

    const determineShow = ( param ) => {
     

        switch(param) { 
            
            case 'show':
                setPackageName('');
                setPackagePrice('');
                setPackageImage('');
                setPackageCategory('');
                setPackageLocation('');
                setPackageStatus('');
                setPackageStars('');
                setPackageId('');
                setTableShow(true);
                setAddShow(false);
                setUpdateShow(false);
                setDeleteShow(false);
                break;

            case 'update':
                setTableShow(false);
                setAddShow(false);
                setUpdateShow(true);
                setDeleteShow(false);
                break;

            case 'delete':
                setTableShow(false);
                setAddShow(false);
                setUpdateShow(false);
                setDeleteShow(true);
                break;

            case 'add':
                setTableShow(false);
                setAddShow(true);
                setUpdateShow(false);
                setDeleteShow(false);
                break;
        }
    }

    const updateRecord = async (e) => {
        e.preventDefault();
        const docRef = doc(db, "packages", packageId);
    
    const data = {

      name : packageName,
      description : packageDesc,
      image: packageImage,
      category: packageCateogry,
      price: packagePrice,
      status: packageStatus,
      // photos []
      // sections []

      stars : packageStars,
      location: packageLocation
    };
    
    if (packageName === ''  ) {
        setError(' يرجى ادخال اسم البكج ');
}

if (packageImage === ''  ) {
setError(' يرجى ادخال صورة البكج ');
}


if (packageCateogry === ''  ) {
setError(' يرجى ادخال فئة البكج ');
}

if (packagePrice === ''  ) {
setError(' يرجى ادخال سعر البكج ');
}




if (packageStars === ''  ) {
setError(' يرجى ادخال عدد نجوم البكج ');
}
if (packageLocation === ''  ) {
setError(' يرجى ادخال مكان البكج ');
}
if (packageStatus === ''  ) {
setError(' يرجى ادخال حالة البكج ');
}


    if (error === '') {
        setDoc(docRef, data)
    
        setSuccess(true);
        setTimeout(() => {
            setSuccess('');
            determineShow('show');
        } , 1350);
    }

  
    
    
      }

      const deleteRecord = async (e) => {
        e.preventDefault();
      
        await deleteDoc(doc(db, "packages", packageId));
        setSuccess(true);
        setTimeout(() => {
            setSuccess('');
            determineShow('show');
        } , 1350);
      }
  
      
   

    return(
        <div className="main_admin">

    <div className="sidebar_admin">
    <SideBar menu={sidebar_menu} />
    </div>

    <div className="content_admin">
    <div className='dashboard-content'>
            

            <div className='dashboard-content-container'>

            {addShow && (
                <>
                <div className='dashboard-content-header'>

                <h2 className='admin_headline' >اضافة بكج  </h2>
                <div className='dashboard-content-search'>
                    
                <button className="dashbord-header-btn_2" onClick={() => determineShow('show') } >رؤية جميع البكجات</button>
                    </div>           

                </div>

                {error && (
                            <>
                            <h1 className="my-1 error_headline"> {error} </h1>
                            </>
                        )}

                {success && (
                    <>
                        <div className="popup_success">
                            <img src="/images/icons/check.png" alt="" />
                        </div>
                    </>
                )}
                          
                <form onSubmit={addNewPackage} >

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> اسم البكج </label>
               
                <input value={packageName} onChange={ (e) => setPackageName(e.target.value)  } type="text" id='name' className="input_form" placeholder='اسم البكج...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> وصف البكج </label>
               
                <input value={packageDesc} onChange={ (e) => setPackageDesc(e.target.value)  } type="text" id='name' className="input_form" placeholder='اسم البكج...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> صورة البكج </label>
               
                <input value={packageImage} onChange={ (e) => setPackageImage(e.target.value)  } type="text" id='name' className="input_form" placeholder='صورة البكج...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1">    سعر البكج </label>
               
                <input value={packagePrice} onChange={ (e) => setPackagePrice(e.target.value)  } type="text" id='name' className="input_form" placeholder='سعر البكج ...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> فئة البكج </label>
            <select required name="category" id="category" value={packageCateogry} className="input_form" onChange={(e) => {
        const selectedCategory = e.target.value;
        setPackageCategory(selectedCategory);
      }} >
      <option value=""   hidden>اختر الفئة</option>
      <option value="event">  فعالية </option>
      <option value="public_place">  مكان عام  </option>
      <option value="tourist">   منتجع سياحي  </option>
      <option value="coffee">   كوفيه  </option>
      <option value="restaurant">   مطعم  </option>
     
      </select>
               
            </div>




            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> حالة البكج </label>
               
            <select required name="category" id="category" value={packageStatus} className="input_form" onChange={(e) => {
        const selectedStatus = e.target.value;
        setPackageStatus(selectedStatus);
      }} >
      <option value=""   hidden> اختر الحالة </option>
      <option value="new">  جديد </option>
      <option value="most_popular">  الاكثر مبيعا   </option>
      <option value="most_people">    الشعبي  </option>
     
      </select>
            </div>

         

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1">   صور المكان </label>
               
                <input value={photoUrl} onChange={ (e) => setPhotoUrl(e.target.value)  } type="text" id='name' className="input_form" placeholder=' اضافة صور للمكان...' />

                <button className="dashbord-header-btn_2 w-80 mt-1" onClick={() => pushIntoPhotos(photoUrl) } >اضافة الصورة</button>

            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1">   اقسام المكان </label>
               
                <input value={placeName} onChange={ (e) => setPlaceName(e.target.value)  } type="text" id='name' className="input_form mt-1" placeholder=' اسم القسم.' />
               
                <input value={placeDesc} onChange={ (e) => setPlaceDesc(e.target.value)  } type="text" id='name' className="input_form mt-1" placeholder=' وصف القسم.' />
               
                <input value={placeImage} onChange={ (e) => setPlaceImage(e.target.value)  } type="text" id='name' className="input_form mt-1" placeholder=' صورة القسم.' />

                <button className="dashbord-header-btn_2 w-80 mt-1" onClick={() => pushNewSection(placeName , placeDesc , placeImage) } >اضافة قسم</button>

            </div>

           



         
            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> MAP -   موقع المكان </label>
               
                <input value={packageLocation} onChange={ (e) => setPackageLocation(e.target.value)  } type="text" id='name' className="input_form" placeholder='موقع المكان...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1">  مرتبط مع العلامة </label>
            <select required name="category" id="category" value={refereLocation} className="input_form" onChange={(e) => {
        const selectedCategory = e.target.value;
        setRefereLocation(selectedCategory);
      }} >
      <option value=""   hidden>اختر المكان</option>
      {supportedPlaces && (
        supportedPlaces.map(( {place_headline } ) => (
         
            <option value={place_headline}> {place_headline} </option>

        ))
      )}
     
      </select>
               
            </div>
         


            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> تقييم مكان البكج </label>
            <select required name="stars" id="stars" value={packageStars} className="input_form" onChange={(e) => {
        const selectedStar = e.target.value;
        setPackageStars(selectedStar);
      }} >
      <option value=""   hidden>اختر عدد النجوم</option>
      <option value="1">  1 </option>
      <option value="2">  2   </option>
      <option value="3">   3   </option>
      <option value="4">   4  </option>
      <option value="5">   5  </option>
     
      </select>
               
            </div>

     

            <button  type='submit' className="dashbord-header-btn_2 w-80">اضافة البكج</button>


            </form>
                </>

            )}
            
            {updateShow && (
                <>
                <div className='dashboard-content-header'>

                <h2 className='admin_headline' >تعديل العلامة </h2>
                <div className='dashboard-content-search'>

                <button className="dashbord-header-btn_2" onClick={() => determineShow('show') } >رؤية جميع العلامات</button>
                    </div>           

                </div>

                {error && (
                            <>
                            <h1 className="my-1 error_headline"> {error} </h1>
                            </>
                        )}

                {success && (
                    <>
                        <div className="popup_success">
                            <img src="/images/icons/check.png" alt="" />
                        </div>
                    </>
                )}
                          
                <form onSubmit={updateRecord} >

                <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> اسم البكج </label>
               
                <input value={packageName} onChange={ (e) => setPackageName(e.target.value)  } type="text" id='name' className="input_form" placeholder='اسم البكج...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> وصف البكج </label>
               
                <input value={packageDesc} onChange={ (e) => setPackageDesc(e.target.value)  } type="text" id='name' className="input_form" placeholder='اسم البكج...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> صورة البكج </label>
               
                <input value={packageImage} onChange={ (e) => setPackageImage(e.target.value)  } type="text" id='name' className="input_form" placeholder='صورة البكج...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> فئة البكج </label>
            <select required name="category" id="category" value={packageCateogry} className="input_form" onChange={(e) => {
        const selectedCategory = e.target.value;
        setPackageCategory(selectedCategory);
      }} >
      <option value=""   hidden>اختر الفئة</option>
      <option value="event">  فعالية </option>
      <option value="public_place">  مكان عام  </option>
      <option value="tourist">   منتجع سياحي  </option>
      <option value="coffee">   كوفيه  </option>
      <option value="restaurant">   مطعم  </option>
     
      </select>
               
            </div>




            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> حالة البكج </label>
               
            <select required name="category" id="category" value={packageStatus} className="input_form" onChange={(e) => {
        const selectedStatus = e.target.value;
        setPackageStatus(selectedStatus);
      }} >
      <option value=""   hidden> اختر الحالة </option>
      <option value="new">  جديد </option>
      <option value="most_popular">  الاكثر مبيعا   </option>
      <option value="most_people">    الشعبي  </option>
     
      </select>
            </div>

         

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1">   صور المكان </label>
               
                <input value={photoUrl} onChange={ (e) => setPhotoUrl(e.target.value)  } type="text" id='name' className="input_form" placeholder=' اضافة صور للمكان...' />

                <button className="dashbord-header-btn_2 w-80 mt-1" onClick={() => pushIntoPhotos(photoUrl) } >اضافة الصورة</button>

            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1">   اقسام المكان </label>
               
                <input value={placeName} onChange={ (e) => setPlaceName(e.target.value)  } type="text" id='name' className="input_form mt-1" placeholder=' اسم القسم.' />
               
                <input value={placeDesc} onChange={ (e) => setPlaceDesc(e.target.value)  } type="text" id='name' className="input_form mt-1" placeholder=' وصف القسم.' />
               
                <input value={placeImage} onChange={ (e) => setPlaceImage(e.target.value)  } type="text" id='name' className="input_form mt-1" placeholder=' صورة القسم.' />

                <button className="dashbord-header-btn_2 w-80 mt-1" onClick={() => pushNewSection(placeName , placeDesc , placeImage) } >اضافة قسم</button>

            </div>

           



         
            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1">  MAP - موقع المكان </label>
               
                <input value={packageLocation} onChange={ (e) => setPackageLocation(e.target.value)  } type="text" id='name' className="input_form" placeholder='موقع المكان...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1">  مرتبط مع العلامة </label>
            <select required name="category" id="category" value={refereLocation} className="input_form" onChange={(e) => {
        const selectedCategory = e.target.value;
        setRefereLocation(selectedCategory);
      }} >
      <option value=""   hidden>اختر المكان</option>
      {supportedPlaces && (
        supportedPlaces.map(( {place_headline } ) => (
         
            <option value={place_headline}> {place_headline} </option>

        ))
      )}
     
      </select>
               
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> تقييم مكان البكج </label>
            <select required name="stars" id="stars" value={packageStars} className="input_form" onChange={(e) => {
        const selectedStar = e.target.value;
        setPackageStars(selectedStar);
      }} >
      <option value=""   hidden>اختر عدد النجوم</option>
      <option value="1">  1 </option>
      <option value="2">  2   </option>
      <option value="3">   3   </option>
      <option value="4">   4  </option>
      <option value="5">   5  </option>
     
      </select>
               
            </div>

            <button className="dashbord-header-btn_2 w-80" type='submit' >تعديل ملعومات البكج</button>


            </form>
                </>

            )}
            
            {deleteShow && (
                <>
                <div className='dashboard-content-header'>

                <h2 className='admin_headline' > حذف البكج </h2>
                <div className='dashboard-content-search'>

                <button className="dashbord-header-btn_2" onClick={() => determineShow('show') } >رؤية جميع الشركاء</button>
                    </div>           

                </div>

                {error && (
                            <>
                            <h1 className="my-1 error_headline"> {error} </h1>
                            </>
                        )}

                {success && (
                    <>
                        <div className="popup_success">
                            <img src="/images/icons/check.png" alt="" />
                        </div>
                    </>
                )}
                          
                <form onSubmit={deleteRecord} >

              
          

            <button className="dashbord-header-btn_2 w-80 bg_red" type='submit'  >حذف العلامة</button>


            </form>
                </>

            )}

            {showTable && (
                <>
                <div className='dashboard-content-header'>
                    <h2 className='admin_headline' >قائمة البكجات </h2>
                    <div className='dashboard-content-search'>

                <button className="dashbord-header-btn_2" onClick={() => determineShow('add') } >  اضافة بكج جديد</button>
                    </div>   
                   
                </div>

                {packagesArray && (
                    <table className='admin_table_dashboard' >
                    <thead>
                        
                        <th className='table_item' >اسم البكج</th>
                        <th className='table_item'> صورة البكج </th>
                        <th className='table_item'>فئة البكج</th>
                        <th className='table_item'>سعر البكج </th>
                        <th className='table_item'>التعديل \ الحذف</th>

                    </thead>

                    <tbody>

                        {packagesArray.map((item , i) => (
                            <tr key={i} >

                         
                            <td className='table_item_sm' > {item.name} </td>
                            <td    > 
                                <img src={item.image} alt="" className="icon_big" />
                             </td>

                             <td className='table_item_sm' > {item.category} </td>
                             <td className='table_item_sm' > {item.stars} </td>
                            <td className='d-flex-c' >
                            <button className="edit_btn_admin" onClick={() => updateShownMethod(  item.name , item.image , item.category , item.description , item.lattiude , item.langitude , item.stars    , item.location , item.id   )  }  >تعديل</button>
                            <button className="delete_btn_admin" onClick={() => deleteShowMethod( item.name , item.image , item.category , item.description , item.lattiude , item.langitude , item.stars    , item.location  , item.id ) } >حذف</button>
                            </td>

                        </tr>
                        ))}


                    </tbody>

               
                </table>
                )}

              
                </>
            )}
                
             

               
            </div>
        </div>
    </div>

        </div>
    
    )
}

export default PackagesMangment;